export const isKeplrBrowser = "keplr" in window &&
    typeof window.keplr === "object" &&
    window.keplr !== null &&
    "mode" in window.keplr &&
    window.keplr.mode === "mobile-web";
export const isLeapBrowser = window.navigator.userAgent.includes("LeapCosmos");
export const isOkxBrowser = window.navigator.userAgent.includes("OKApp");
